import es from './es';
import en from './en';
import fr from './fr';
import nl from './nl_NL';
import it from './it';
import ro from './ro';
import pl from './pl';

const resources = {
  es,
  en,
  fr,
  nl,
  it,
  ro,
  pl,
};

export const config = {
  resources: resources,
};
